// @flow
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'

// TODO Set the correct article ID here
const ARTICLE_ID = '10653040'

const isMobile = window.innerWidth < 800

class AppComponent extends Component<Props, State> {
  render() {
    return (
      <div className='index'>
        <ThemeSwitch mediaName='dasmagazin' />
        <Masthead
          articleId={ARTICLE_ID}
          inverted
          mediaName='dasmagazin'
          fullMediaName='Das Magazin'
          homepage='https://www.dasmagazin.ch'
          additionalShares={212}
        />

        <header className='ui container titleImage'>
          {/* <img src='images/baskast.jpg' /> */}

          <div className='headline'>
            <h1>VOLLES RISIKO</h1>
            <div className='byline'>
              Eine Partei umkrempeln mitten im Wahljahr – das hat in der Schweiz
              noch niemand versucht. Dann kam Petra Gössi.
            </div>
          </div>
          <div className='author'>Philipp Loser</div>
        </header>
        <div className='ui container'>
          <div className='ta secondary caption'>
            {' '}
            Rechtsberaterin, Nationalrätin, Präsidentin der FDP: Petra Gössi.
            Foto: Joan Minder
          </div>
        </div>

        <div className='ui vertical segment '>
          <div className='ui text container'>
            <p>&nbsp;</p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'startReading'
              })
            }
          }}
        />

        {/* TEXT */}
        <div className='ui vertical segment interviewText'>
          <div className='ui text container'>
            <p>
              Der Nationalratssaal im Bundeshaus in Bern kann der lauteste und
              aufregendste Ort der Schweiz sein. Wenn Debatten aus dem Ruder
              laufen, Zwischenrufe für einen Protokolleintrag sorgen
              («allgemeine Heiterkeit»), Bundesräte und manchmal Bundesrätinnen
              gewählt werden.
            </p>
            <p>
              Der Nationalratssaal im Bundeshaus in Bern kann der
              deprimierendste Ort der Schweiz sein. Trostlos und düster und
              leer. Wie jetzt, an diesem Donnerstagabend im Juni. Die Lichter
              sind gedimmt, in den Gängen liegt Papier, Stühle stehen herum,
              jemand hat seinen Laptop vergessen.
            </p>
            <p>
              Nur ganz hinten, auf den Holzthronen der Ständerätinnen und
              Ständeräte mit den geschnitzten Kantonswappen, sitzen Petra Gössi,
              Präsidentin der FDP, und Damian Müller, Ständerat der Partei. Sie
              stecken ihre Köpfe so nahe zusammen, wie es nur Menschen tun, die
              sich etwas Wichtiges, etwas Geheimes zu erzählen haben.
            </p>
            <p>
              Petra Gössi, 43 Jahre alt, ist seit drei Jahren Vorsitzende der
              Freisinnig-Demokratischen Partei der Schweiz und steht vor dem
              wichtigsten Moment ihrer Präsidialzeit. In zwei Tagen sollen die
              Delegierten der Partei den neuen Umweltkurs gutheissen. Es wird
              auch eine Entscheidung über Gössi sein. War es richtig, die FDP
              auf Grün zu drehen? Will das die Partei? Nützt es ihr? Falls ja:
              Kann sie diesen Kurs konsequent vertreten?
            </p>
            <p>
              Es ist Wahljahr, und Petra Gössi wagt etwas, was noch niemand in
              einem Wahljahr gewagt hat. U-Turn. Umkehrung einer Partei. Für
              Schweizer Verhältnisse ist das geradezu spektakulär. Sie selber
              scheint es nicht weiter zu bekümmern. «Was wäre die Alternative
              gewesen? Nichts tun?», hatte sie einige Tage zuvor im Restaurant
              des Bundeshauses, der Galerie des Alpes, rhetorisch gefragt.
              Andere Politiker hätten in diesem Moment die Stimme erhoben, des
              dramatischen Effekts wegen. Gössi nippte bloss an ihrem Saft. Oben
              war die Sommersession im Gang und alles sehr nervös. In einem
              Wahljahr sind Sessionen anders – plötzlich geht es um etwas, bei
              manchen um die politische Existenz. «Ich finde das schrecklich»,
              sagte Gössi, «als gäbe es kein Leben neben der Politik.» So wie
              sie das sagte, meinte sie es eher beobachtend als wertend. Auch
              nach acht Jahren im Bundeshaus wirkt sie mitunter wie am falschen
              Ort. All die Aufregung, all das Getöse – dabei möchte sie doch
              bloss in Ruhe arbeiten.
            </p>
            <p>
              Arbeit hat sie gerade mehr als genug. Gegen aussen. Gegen innen.
              Zwei Tage noch bis zu der entscheidenden Delegiertenversammlung in
              Zürich, und es läuft nicht gut. Es läuft sogar richtig schlecht.
              Darum sitzt sie jetzt auch noch im Saal und bespricht sich leise
              mit Damian Müller. Der Luzerner ist ein Verbündeter, er hat am
              Umweltpapier mitgearbeitet, stützt den neuen Kurs – ihren Kurs.
              Und er hat heute mitangesehen, wie die «Chefin», so nennen sie
              Petra Gössi in der Partei, von ihren eigenen Leuten desavouiert
              wurde.
            </p>
            <p>
              Im Nationalrat wurden die Trinkwasser-Initiativen behandelt, die
              den Pestizideinsatz in der Schweizer Landwirtschaft radikal
              einschränken wollen. In der FDP-Fraktion hatte man sich zuvor auf
              einen Gegenvorschlag geeinigt, einen Kompromiss, der den Bauern
              weit entgegengekommen wäre. Doch im Rat kommt dann alles anders.
              Die bauernnahen Leute in der Partei schwenken um, die Romands
              schliessen sich ihnen an, und am Schluss stehen Petra Gössi und
              ihr Fraktionschef Beat Walti fast alleine da. Der erste richtige
              Test für den neuen Umweltkurs der FDP: völlig misslungen.
              «Etikettenschwindel», höhnt Regula Rytz, die Präsidentin der
              Grünen. «Leere Versprechen!», schimpft Balthasar Glättli,
              Fraktionschef der Grünen. Und in der FDP selber freuen sich jene,
              die es schon immer gewusst haben: dummes Zeug, dieses grüne Getue.
            </p>
          </div>
        </div>

        {/* ZITAT */}
        <div className='ui vertical segment zitat left grey'>
          <div
            className='imageHolder'
            style={{ backgroundImage: 'url("images/goessi1.jpg")' }}
          />
          <div className='textHolder'>
            <div className='quote'>
              <p>«Was wäre die Alternative gewesen? Nichts tun?»</p>
            </div>
          </div>
        </div>

        <div className='ui vertical segment interviewText'>
          <div className='ui text container'>
            <p>
              Petra Gössi und Damian Müller verlassen den Saal durch
              verschiedene Ausgänge. Als Gössi hinaustritt, hält sie ihr Handy
              wie einen toten Vogel in der Hand. Kaputt, seit heute. Sie sagt
              etwas zur Debatte, aber es ist nicht besonders stringent, sie ist
              heiser, eine Erkältung. Sie will jetzt lieber weg. Entschuldigen
              Sie bitte.
            </p>
            <p>
              Petra Gössi hat ein hartes halbes Jahr hinter sich. Man merkt es
              ihr an, ihr und ihrem engsten Mitarbeiter, dem FDP-Generalsekretär
              Samuel Lanz. Lanz (ausgehende Mails pro Jahr: 30 000, eingehende
              Mails: 45 000) sieht mager aus, bleich, er rasiert sich zu selten
              und zischt jedes Mal, wenn man ihm im Bundeshaus oder im Zug über
              den Weg läuft, eine böse Bemerkung über die Politik, die
              Menschheit, die Welt. «Hast du mir einen anderen Job?» 
            </p>
            <p>
              Bei Gössi sind die Veränderungen subtiler. Sie lacht nicht mehr so
              häufig, ist ständig erkältet. Das Videoteam der FDP macht in der
              Sommersession Aufnahmen von ihr für den Wahlkampf. Sie werden alle
              wieder gelöscht. Unbrauchbar. Die Chefin: zu bleich.
            </p>
            <p>
              Natürlich ist der Druck gross. Die Partei ist vorbelastet. In
              ihrer über hundertjährigen Geschichte hat die FDP schon öfter die
              Richtung gewechselt. Hat den EU-Beitritt zum Ziel erklärt und
              wieder aus dem Parteiprogramm gekippt. Ging nach rechts, nach
              links, mal abrupt, mal schleichend. Es kam selten gut. Wird es
              diesmal anders sein? Wird die eigene Partei den neuen Umweltkurs
              goutieren? Die manchmal feindselige Fraktion im Bundeshaus? Und
              ist Petra Gössi, die Rechtsberaterin aus Küssnacht am Rigi, die
              richtige Person dafür? Er stehe mit Besen und Schaufel bereit,
              sagt ein Freisinniger dem «Tages-Anzeiger» vor der Sommersession,
              «um die Scherben dieser überhasteten Aktion aufzuwischen». Er
              bleibt anonym, natürlich.
            </p>
            <p>
              Zwei Tage noch bis zur Delegiertenversammlung in
              Zürich-Altstetten. Zwei Tage.
            </p>
            <h2>Der Stunt</h2>
            <p>
              Als Petra Gössi im Frühling 2016 zur Präsidentin der FDP gewählt
              wurde, stand sie verloren auf der Bühne des Hotel National in Bern
              und sagte: «Spinne ich eigentlich, dass ich die Einzige bin, die
              das machen will?» Ihr Auftritt und ihre Wahl (337 Stimmen von 337
              Stimmen) gingen fast unter. Schuld war ihr Vorgänger. Philipp
              Müller machte ein wahnsinniges Tamtam um seinen Abgang, riss einen
              Witz nach dem anderen, wollte fast nicht mehr von der Bühne.
              Blumen, Geschenke, mehr Geschenke, Palimpalim. Einen hab ich noch.
              Als spielte es keine Rolle, wer nach ihm den Laden übernimmt.
            </p>
            <p>
              «Philipp hat uns die Lust auf mehr Erfolg ins Herz gepflanzt»,
              sagte Bundesrat Johann Schneider-Ammann und traf damit den
              Zeitgeist in der Partei recht genau. Gewinnen. Einfach so. Ohne
              nachzudenken. Müller hatte, das ist sein historisches Verdienst,
              seine Partei wieder «cool» gemacht. Aus einer Partei der kalten
              Technokraten und herzlosen Millionäre eine Partei der
              Kinderhüpfburgen und kosten­losen Bratwürste. In der Präsidialzeit
              von Philipp Müller ging es immer zuerst um ein Gefühl, um die
              Atmosphäre, das Miteinander – erst danach um Inhalte. Ein
              FDP-Anlass sei erst dann ein guter Anlass, wenn man mindestens
              zweimal lachen müsse, sagte Müller mal.
            </p>
            <p>
              Der Erfolg gab ihm recht, auch wenn er ihn nie wirklich erklären
              konnte. Bei den Wahlen 2015 gewinnt der Freisinn Wähleranteile
              hinzu, zum ersten Mal seit 1979. Der Niedergang gestoppt, die
              Partei der Staatsgründer auf einer Welle des Erfolgs.
            </p>
            <p>
              Petra Gössi reitet mit. Die äusserst sanfte Umsetzung der
              Masseneinwanderungsinitiative gelingt massgeblich dank ihrer FDP;
              aus der Suche nach den Nachfolgern für die Bundesräte Didier
              Burkhalter und Johann Schneider-Ammann machen Gössi und Lanz eine
              erfolgreiche PR-Show durch alle Landesteile, und in den Kantonen
              geht es weiter wie im Wahlherbst 2015. Sieg um Sieg um Sieg. Plus
              33 Sitze in den kantonalen Parlamenten. Im Wahl­barometer gleich
              stark wie die SP. Das deklarierte Ziel der FDP: die SP überholen
              und zweitstärkste Partei werden. Wahlkampfgetöse, das man von 2015
              kennt, das keiner wirklich ernst nahm. Bis jetzt. Ist es doch
              möglich?
            </p>
            <p>Wer soll diesen Freisinn stoppen?</p>
            <p>
              Dann wird es 2018. Der Sommer ist heisser als sonst, er will gar
              nicht mehr aufhören und dauert bis weit in den Herbst. In den
              Zeitungen drucken sie Bilder von Schweizer Feldern, die aussehen
              wie Wüstengebiet. Bauern klagen über fehlendes Wasser,
              Klimaforscher sagen: Gewöhnt euch dran.
            </p>
            <p>
              Da baut sich etwas auf, da entsteht etwas, leise und doch
              dringlich. In der FDP-Fraktion spürt man es nicht. Als es Winter
              wird und das Parlament sich im Dezember 2018 zur Session trifft,
              entstellt die rechte Mehrheit von SVP und FDP das CO2-Gesetz bis
              zur Unkenntlichkeit. Da bleibt so wenig, dass das gesamte Gesetz
              danach vom Nationalrat versenkt wird. Und schuld daran: die FDP.
              Im Onlinemagazin «Republik» sagt Hans-Peter Fricker, ein
              Freisinniger und ehemaliger Chef des WWF: «Die FDP hat in den
              ver­gangenen zwei Wochen die Schweizer Klimapolitik verraten.»
            </p>
            <p>
              Drei Tage nachdem der Nationalrat das CO2-Gesetz abgeschossen hat,
              gehen in Zürich fünfhundert Schülerinnen und Schüler auf die
              Strasse. «Stop wrecking our planet – we want actions now», steht
              in fehlerhaftem Englisch auf einem Plakat. Es ist der Beginn der
              Schweizer Klimastreiks. Plötzlich redet das ganze Land über das
              Thema. Über die Erderwärmung, über die Zukunft des Planeten. Als
              die schwedische Aktivistin Greta Thunberg im Januar nach Davos ans
              Weltwirtschaftsforum kommt, wird sie von einem Medienaufgebot
              empfangen, das ähnlich gross ist wie beim Besuch von US-Präsident
              Donald Trump im Jahr zuvor. Der Satiriker Michael Elsener
              the­ma­tisiert das CO2-Gesetz in der Premieren-Ausgabe seiner
              Sendung «Late Update» und präsentiert eine neue Bedeutung für die
              Abkürzung FDP: «Fuck de Planet». Zwei Wochen später halten
              Schülerinnen und Schüler Schilder mit diesem Slogan in die Höhe,
              stilecht in FDP-Blau. Es sind jetzt nicht mehr fünfhundert
              Jugendliche, die auf die Strasse gehen. Sondern an die
              vierzigtausend. Politgeograf Michael Hermann sagt: «Im letzten
              heissen Sommer ist ein Damm gebrochen. Jetzt ist es Winter, es ist
              kalt, und trotzdem ist das Thema nicht verschwunden. Die Leute
              sind offensichtlich bereit, den Klimawandel als ein Problem zu
              begreifen.»
            </p>
            <p>
              Auch im Freisinn setzt ein Umdenken ein. Am 31. Januar 2019
              treffen sich im Zürcher Hotel Walhalla 21 FDPler zur
              Strategiesitzung. Dabei sind, neben dem erwähnten Ex-WWF-Chef
              Fricker, auch Beat Kälin, Präsident der FDP Meilen und des WWF
              Zürich, und Peter Metzinger, Unternehmer, Lokalpolitiker und
              ehemaliger Kampagnenleiter bei Greenpeace. Dieser lässt sich
              daraufhin mit dem Satz zitieren: «Es gibt nur noch wenige
              Freisinnige, die glauben, Umweltpolitik sei gar kein Thema für die
              FDP.»
            </p>
            <p>
              Und das, so wird der restlichen Schweiz zwei Wochen später klar,
              denkt auch die Chefin: Anfang Februar meldet sich der
              Kommunikationsverantwortliche der FDP, Martin Stucki, bei der
              Inlandredaktion der Tamedia-Zeitungen und bietet ein Interview mit
              Petra Gössi an. Exklusiv. Die FDP und das Klima. Die FDP und der
              Umweltschutz.
            </p>
            <p>
              Das Interview erscheint am Samstag, 16. Februar, und es ist
              spektakulär. Eine Kehrtwende. Gössi bietet nun Hand für eine
              Flugticketabgabe und ein Inlandziel für CO2-Reduktionen. Sie
              kündigt eine Umfrage bei der Basis an. Hundertzwanzigtausend
              Mitglieder sollen ihre Meinung zur freisinnigen Umweltpolitik
              abgeben. Sie sagt: «Wir sind keine klimafeindliche Partei.» Sie
              sagt: «Wir wollen eine wirk­same Klimapolitik.» Sie sagt: «Es ist
              selbstverständlich, dass man die Politik anpassen kann.»
            </p>
            <p>
              Dass Gössi das Interview geben würde, wusste nur der innerste
              Zirkel. Die Fraktion erfährt die Kurskorrektur aus der Zeitung.
              Die Fraktion tobt. Nationalrat Christian Wasserfallen aus dem
              Kanton Bern ist der Wortführer jener Kräfte in der Partei, die das
              CO2-Gesetz entscheidend abgeschwächt ­haben. Er twittert und geht
              sofort auf Konfrontation: «Was man alles aus der Zeitung erfährt.
              Wir sind nicht für wirkungslose Flugticketabgabe. Kühlen Kopf im
              Wahljahr bewahren.» Ein anstrengendes Wochenende für das
              Generalsekretariat. «Einige haben wahnsinnig täubelet», sagt
              Samuel Lanz.
            </p>
            <p>
              Petra Gössi geht auf tutti. Die eigene Fraktion: zutiefst
              beleidigt. Die Unterstützung der Basis: ungewiss. Die Reaktionen
              in der Öffentlichkeit: ungläubig bis mitleidig. Ist der Freisinn
              so nervös, dass er jetzt auf grün macht?
            </p>
            <p>
              Oft wird die FDP-Präsidentin in den Tagen und Wochen danach
              gefragt, warum sie das getan habe. Warum gerade jetzt? Warum nicht
              früher? Und meint sie das wirklich ernst? Ihre Antworten
              variieren, sind aber im Kern konstant. Man habe das Problem nicht
              länger ignorieren können. Alternativlos. Sagt sie in der Galerie
              des Alpes im Bundeshaus, auf einer Autofahrt von Tuggen nach
              Zürich, in einem Tram in Langenthal, bei einem Kaffee in ihrem
              Büro am General-Guisan-Quai in Zürich. Sie sagt es immer wieder,
              muss es immer wieder sagen: «Die Rückmeldungen aus den Kantonen
              waren überdeutlich.» Es gehe ihr nicht um die elektorale
              Perspektive, sonst sei man nicht mehr glaubwürdig, es gehe ihr
              tatsächlich um den Schutz der Umwelt. «Dieser ist in der DNA
              unserer Partei verankert.» Es sei doch logisch, dass jeder Mensch,
              der wie sie gern in der Natur sei, diese auch schützen und
              bewahren wolle. So simpel.
            </p>
            <h2>Grüne Wurzeln</h2>
            <p>
              Was man auf den ersten Blick nicht sieht: Es ist nicht nur der
              Zeitgeistdruck, der Gössi zu ihrem Manöver verleitet. Das Manöver
              hat auch einen strategischen Unterboden. Zum ersten Mal seit
              Jahren schwächelt die grösste Partei der Schweiz, die SVP,
              spürbar. Sie hat keine Themen, keine Resonanz, sie verliert in den
              Kantonen Wahl um Wahl. Das Risiko für die FDP, mit dem Umweltthema
              die rechte Flanke zu öffnen, ist so gering wie noch nie.
              Gleichzeitig wachsen links die Grünliberalen zu einer ernsthaften
              Bedrohung heran. Die Lagebeurteilung recht eindeutig: Es muss
              jetzt sein.
            </p>
            <p>
              Schon Gössis Vorgänger hat das versucht. Nach einem Mittagessen
              mit Elisabeth Kopp, der ersten Bundesrätin der FDP, und nach dem
              Besuch von über dreihundert Veranstaltungen der Parteibasis, war
              Philipp Müller plötzlich klar: Die Natur zählt. Auch Müller gab
              Interviews zum Umweltschutz, er kündigte eine grünere, eine
              ökologischere Partei an – und scheiterte. Der Druck war nicht so
              gross. Die Ausgangslage anders. Er selbst nicht so entschlossen.
            </p>
            <p>
              Aber dass die FDP im Kern eine irgendwie grüne Partei sei, davon
              sind beide überzeugt, Gössi und Müller. Gössi erzählt gerne und
              oft, dass es Freisinnige gewesen sind, die den ersten Nationalpark
              und Pro Natura gründeten. Doch so richtig dominant war
              Umweltschutz eigentlich nur während einer bestimmten Episode in
              der hundertjährigen Geschichte des Freisinns. 1983, als das
              Waldsterben in der öffentlichen Diskussion so dominant war wie
              heute der Klimawandel, entstand in der Basis eine Diskussion, der
              heutigen nicht unähnlich. Umweltschutz war ein Problem, auf das
              die Partei, die überall «weniger Staat» forderte, keine Antwort
              hatte.
            </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '25ContentRead'
              })
            }
          }}
        />

        {/* ZITAT */}
        <div className='ui vertical segment zitat right'>
          <div
            className='imageHolder'
            style={{ backgroundImage: ' url("images/goessi3.jpg")' }}
          />
          <div className='textHolder'>
            <div className='quote'>
              <p>
                «Es ist doch logisch, dass jeder Mensch, der gern in der Natur
                ist, sie beschützen und bewahren will.»
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical segment interviewText'>
          <div className='ui text container'>
            <p>
              Die grüne Hoffnung kam aus Zumikon und hiess Elisabeth Kopp. Sie
              war dort Gemeindepräsidentin, als sie 1979 in den Nationalrat
              gewählt wurde. Kurz darauf installierte die Zürcher FDP unter
              Kopps Leitung eine neue Kommission für Umweltschutz. Im Parlament
              setzte sie sich erfolgreich dafür ein, dass der Bundesrat die
              Katalysatorpflicht beschloss. In den folgenden Jahren wurde sie
              «zum Gesicht für einen neuen Umgang der FDP mit dem Thema
              Umweltschutz», wie ihr Biograf René Lüchinger schreibt.
            </p>
            <p>
              Kopps Wahl in den Bundesrat machte aus dem Umweltschutz, lange
              fast ausschliesslich Thema der Linken, einen festen Bestandteil
              der freisinnigen Agenda. Im Oktober 1986 verabschiedeten die
              FDP-Delegierten in Bern ein Manifest, das sogar Lenkungsabgaben
              vorsah, um den Verbrauch knapper Ressourcen zu senken. Rasch
              erhielten nun auch andere Politiker in der Partei Aufschwung, die
              auf stärkeren Schutz der Umwelt drängten. Die Bielerin Christine
              Beerli, spätere FDP-Fraktionspräsidentin und Bundesratskandidatin,
              trat der FDP in dieser Zeit bei. «Für meine politische
              Soziali­sierung spielten diese Jahre eine wichtige Rolle», sagt
              sie. «Teile der Partei strahlten eine sozialliberale Haltung und
              eine Öffnung in ökologi­schen Fragen aus, die besonders von Frau
              Kopp verkörpert wurde.»
            </p>
            <p>
              Im Mai 1987 bestritt der Baselbieter René Rhinow seinen
              Ständeratswahlkampf ausschliesslich mit dem Thema
              «Ökoliberalismus» und begeisterte damit den damaligen
              FDP-Präsidenten Bruno Hunziker, einen wirtschaftsliberalen
              Aargauer: «Vor zwei Jahren hätte ich gesagt: Es wird schwierig
              sein, diese Einsichten bei uns durchzubringen. Heute sieht es
              anders aus: Zwischen unserem Umweltmanifest und Rhinows
              Ausführungen gibt es grosse geistige Überein­stimmungen.»
            </p>
            <p>
              Doch als 1988 Elisabeth Kopp aus dem Bundesrat zurücktreten musste
              und 1989 die Mauer fiel, blieb nicht mehr viel von den «geistigen
              Übereinstimmungen» übrig. Die FDP hatte nun andere Probleme.
              Ohnmächtig sah sie zu, wie in den folgenden zwei Jahrzehnten
              rechts von ihr die SVP stärker und stärker wurde und sie
              schliesslich überholte. Der Freisinn reagierte zuerst mit einem
              ideologisch wirren Hin und Her auf den Aufstieg der SVP und
              später, in den Nullerjahren, mit einer klaren Ausrichtung nach
              rechts. Auf der Strecke blieb der Umweltschutz. Der Tiefpunkt
              wurde vor zehn Jahren erreicht, als die FDP mit einer
              Volksinitiative das Verbandsbeschwerderecht für Umweltverbände
              abschaffen wollte. Ein Affront für all jene Freisinnigen, die
              irgendwo, irgendwie grün waren.
            </p>
            <p>
              Das ist die Ausgangslage von Petra Gössi. Das grüne Erbe der
              Partei, die «DNA». Umweltschutz im Freisinn: eine historische
              Nebenbeschäftigung weniger, aber sehr engagierter
              Parteimitglieder. Rechtfertigt das die Neuausrichtung einer ganzen
              Partei?
            </p>
            <p>
              Petra Gössi muss die Frage nach den Kantonsratswahlen in Zürich
              vom März 2019 wieder und wieder beantworten. Die Siegesserie der
              Partei wird in Zürich jäh gestoppt. Verlust eines
              Regierungsratsitzes, zum ersten Mal überhaupt nur noch ein
              Freisinniger ­in der Exekutive. Minus zwei Sitze im Kantonsrat.
              Wahlverliererin FDP. Wahlverliererin Petra Gössi. «Bei diesem
              Thema wählt man immer das Original, und das muss uns zu denken
              geben», ätzt FDP-Nationalrat Christian Wasserfallen am Radio,
              natürlich Wasserfallen. Gössis Nemesis. Unterstützt wird der
              Berner Nationalrat von allerlei bösen Tweets verärgerter
              Jungliberaler: «Letzte Alarmglocke: Bitte zurück zu den liberalen
              Werten!» Hashtag: #DankeGössi.
            </p>
            <p>
              Und Gössi? Am Wahltag hört man nichts von ihr. Sie lässt
              Hans-Jakob Boesch den Vortritt, dem Präsidenten der Zürcher
              Kantonalpartei. Er ist ein Unterstützer des neuen Kurses und sagt:
              «Für uns Zürcher kam das Engagement von Petra Gössi zu spät.»
            </p>
            <p>
              Sie selber spricht erst wieder zwei Tage nach den Wahlen. In ihrem
              Heimatort, Küssnacht am Rigi, werden an diesem Abend die Schwyzer
              FDP-Kandidatinnen und -Kandidaten für die eidgenössischen Wahlen
              vom Herbst nominiert. Die Versammlung findet im Industrieareal von
              Küssnacht statt, auf dem Werkhof der Christen AG, und sie ist ein
              Spektakel, wie es seit den Zeiten von Philipp Müller in der FDP
              üblich ist. Freibier, Bratwürste, eine Band. Die Stimmung: so gar
              nicht verkatert. Trotz Zürich. «Umweltpolitik und Umwelt gehen uns
              alle an. Wir haben nur eine Umwelt», sagt Gössi den Delegierten.
              «Bis jetzt wird Umweltpolitik vor allem von links betrieben. Es
              braucht darum unsere Rezepte, unsere Ideen.» Grosser Applaus.
            </p>
            <p>
              Kurz vor der Nomination gibt der Wahlkampfleiter das Wort frei.
              Drei Leute melden sich, niemand redet über die Kandidaten, alle
              sprechen nur über ein Thema: die Umwelt. «Ich habe riesige Freude,
              wie sich Petra für Umweltthemen einsetzt», sagt einer. «Wir waren
              schon immer eine Umweltpartei», der Nächste. Und der Letzte:
              «Gratulation, wie standhaft du in den vergangenen Tagen im Thema
              geblieben bist, Petra. Wir stehen hundert Prozent zu dir.» Die
              paar Jungfreisinnigen im hinteren Teil des Hofs, die sich vor der
              Veranstaltung noch kritisch über die grüne FDP geäussert hatten,
              bleiben stumm. Sie schauen jetzt zu, wie Petra Gössi auf der
              grünen Bühne des Werkhofs steht (Grün ist die Farbe der Christen
              AG – Bagger, Pavatex-Platten, alles grün hier) und wie sie fast
              schon schreit: «Wir rocken das!»
            </p>
            <p>
              Sie wirkt gelöst. So gelöst, wie sie im Bundeshaus nie wirkt. «Üsi
              Petra» wird sie in Küssnacht genannt. Der lokale Parteipräsident
              lobt sie dafür, dass sie sich bis heute für jede verpasste Sitzung
              bei der Ortspartei entschuldige («Das wäre wirklich nicht
              nötig!»), und Gössi macht Werbung für das Jubiläumsfest der
              lokalen Trachtengruppe, dessen OK-Präsidentin sie ist. Mögen sie
              in Bern stürmen und jammern, mögen sie in Zürich twittern und
              sirachen – hier kann ihr niemand etwas. Hier ist sie daheim.
            </p>
            <h2>Küssnacht am Rigi</h2>
            <p>
              Alpenidylle und Businessclass. Geisselchlepfer und Banker in
              steueroptimierten Eigenheimen mit Seesicht. Küssnacht, auf halbem
              Weg zwischen Luzern, Zug und Zürich, ist ein Abbild der modernen
              und ein Abbild der traditionellen Schweiz. Vereint in
              erstaunlicher Harmonie.
            </p>
            <p>
              Petra Gössi ist sehr Küssnacht am Rigi. Schwingfan und
              Akademikerin. Besucherin von Alpchilbis und gut bezahlte
              Steuerberaterin in der Stadt. Kein Widerspruch. Fragt man Gössis
              Umfeld nach ihrer grössten Stärke, kommt immer und bei allen
              zuerst das: Sie ist authentisch. Sie verstellt sich nicht. Und das
              hat wohl viel damit zu tun, dass sie immer hier geblieben ist,
              hier in Küssnacht. Selbst wenn sie unterwegs war, in Bern, um Jus
              zu studieren, in Zürich als Assistentin an der Uni und später bei
              der Arbeit – am Schluss war sie immer wieder hier. Ihre Familie,
              ihre Freunde, ihre Förderer – in Küssnacht ist Gössi befreiter,
              entspannter, frecher auch. Hier ist sie behütet und beschirmt.
            </p>
            <p>
              Besuch bei Alois «Wisel» Christen. Von seiner Stube sind es etwa
              dreihundert Meter Luftlinie bis zur Wohnung von Petra Gössi.
              «Schau, da wohnt s Petra.» Christen lebt mit seiner Frau in einer
              Villa hoch über Küssnacht, ganz am Ende einer Strasse namens
              Bürgenstockhöchi. Vor ihm der See, die Alpen, volle Lieblichkeit.
              Weiter hinten im Tal: seine Firma. Christen hat jene Baufirma
              gross gemacht, in deren giftgrüner Werkhalle die FDP des Kantons
              Schwyz ihre Delegiertenversammlung abgehalten hat. Er war auch
              Politiker: von 1992 bis 2000 im Kantonsrat, danach acht Jahre als
              Vorsteher des Militär- und Polizeidepartements in der Regierung.
              Ein gelernter Hochbauzeichner und Maurer unter lauter Akademikern,
              nicht immer einfach sei das gewesen.
            </p>
            <p>
              Christen, 71 Jahre alt, ist eine Nummer im Dorf. Und eine
              Konstante in Petra Gössis Leben. Berater, väter­licher Freund. Wie
              eine Tochter sei die Petra für ihn. Erst kürzlich waren sie
              zusammen am Eidgenössischen Schwingfest. Er zeige ihr an solchen
              Festen, wen sie unbedingt grüssen müsse, wen man nicht vergessen
              dürfe. «Es sind solche kleinen Dinge, die ich ihr sage, fiini
              Sächeli.» 
            </p>
            <p>
              Ihr Vater, der «Gössi Toni», ist ein guter Freund von Christen. In
              mindestens zehn Vereinen seien sie zusammen im Vorstand gewesen,
              sagt Christen, er und der Toni. Ein guter Mensch, ein fröhlicher
              Mensch, und als er dann mit seiner Tessiner Frau Edy endlich die
              Petra hatte, ein sehr glücklicher Mensch.
            </p>
            <Waypoint
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'Interactions',
                    event_action: 'vertical-scroll',
                    event_label: '50ContentRead'
                  })
                }
              }}
            />
            <p>
              Petra Gössi ist ein Einzelkind, aber sie wächst mit drei Cousins
              und Cou­sinen im gleichen Haus auf. Die Eltern arbeiten beide zu
              hundert Prozent im eigenen Haushaltswarengeschäft, zum Mittagessen
              sitzen alle am Tisch und hören um halb eins das «Rendezvous».
              Politisierung einer sorgenfreien Generation.
            </p>
            <p>
              Die Gössis sind schon lange in Küssnacht, und sie haben immer
              mitgemacht. Beim Klausjagen, der Sennen- und Älplergesellschaft,
              im Frauenverein, in der Müttergesellschaft. Man macht mit, weil
              man mitmacht. Aus Freude. Dörflicher Zusammenhalt.
            </p>
            <p>
              Das Elternhaus katholisch und liberal. Schon der Grossvater und
              ein Onkel sassen für die Liberale Volkspartei – so hiess hier die
              FDP früher – im Kantonsrat. Doch bei Petra Gössi deutet am Anfang
              noch nicht viel auf eine Politkarriere. Am Gymnasium Immensee (das
              auch Simonetta Sommaruga besuchte) färbt sie sich die Haare mit
              Henna, trägt Batikshirts und fährt ein Holländervelo, mit
              Gänse­blumen verziert. Mehr Revolution ist nicht, warum auch. Sie
              ist nicht aufmüpfig, nicht antiautoritär, nicht schwierig. «Mir
              war einfach wichtig, die eigenen Entscheidungen zu treffen.
              Selbstbestimmt zu sein», sagt sie. «Dass ich aufs Gymnasium wollte
              und später an die Universität, das habe ich meinen Eltern jeweils
              mitgeteilt.»
            </p>
            <p>
              Bis zur Anwaltsprüfung läuft alles mit beinahe erschreckender
              Leichtigkeit. Doch dann: Blackout. Sie fällt durch. Ein «Schock»
              und ein «Wendepunkt» sei das gewesen, hat sie schon mehrmals
              erzählt. Aus Trotz hilft sie danach ihrem damaligen Freund, einem
              Koch, beim Aufbau eines Cateringservice, steht in der Küche,
              arbeitet hart. «Das wurde für mich prägend, weil man in der Küche
              unbedingt mit allen zusammenarbeiten können muss. Ich lernte wohl
              nie so gut, auf Leute zuzugehen, wie in dieser Zeit», erzählte sie
              einmal der «Republik».
            </p>
            <p>
              2003 sind eidgenössische Wahlen – und die gehen für die FDP im
              Kanton Schwyz nicht gut aus. Steter Niedergang, wie überall im
              Land. Die Freisinnigen verlieren fast vier Prozent Wähleranteile
              und ihren Schwyzer Nationalratssitz. Nach den Wahlen wird die
              kantonale Partei neu aufgestellt – und Gössis Zeit in der Politik
              beginnt. Sie erhält einen Brief von «Wisel» Christen, der sich bis
              heute brüstet, ihr die Idee eingepflanzt zu haben, für den
              Kantonsrat zu kandidieren. Gleichzeitig wird sie von einem
              ehemaligen Studienkollegen gefragt, ob sie nicht auf die FDP-Liste
              möchte. Sie macht mit, weil man mitmacht. Gemeinsam mit Silvia
              Bähler aus Merlischachen, einer Bisherigen, macht Gössi Wahlkampf
              mit Big Data. Die beiden schreiben alle 18- bis 35-jährigen Frauen
              in ihrem Wahlbezirk an, die Adressen haben sie von der Gemeinde
              (damals ging das noch). Frauen wählen Frauen. Sie wählen auch
              Gössi.
            </p>
            <p>
              «Ich hab ihr gesagt: Du wurdest nur wegen deinem Vater gewählt!»
              Christens Spruch begleitet Gössi bis heute und ist längst zur
              beliebten Anekdote geworden. «Man muss den Satz richtig
              begreifen», sagt Christen in seinem Wohnzimmer mit Blick auf den
              Vierwaldstättersee. «Der Gössi Toni ist der liebste Mensch. Er
              kann es mit allen, er lacht viel. Petra hat sein Blut. Sie ist
              eine goldige.»
            </p>
          </div>
        </div>

        {/* ZITAT */}
        <div className='ui vertical segment zitat right'>
          <div
            className='imageHolder'
            style={{
              backgroundImage: ' url("images/goessi4.jpg")',
              backgroundPositionY: 'bottom'
            }}
          />
          <div className='textHolder'>
            <div className='quote'>
              <p style={{ fontSize: isMobile ? '1.2em' : '2em' }}>
                «Nie in meiner Karriere, weder während des Studiums noch im
                Kantonsrat oder bei meiner Arbeit, war mein Geschlecht ein
                Thema. Nur die Leistung zählte. Seit ich Parteipräsidentin bin,
                ist das anders. Ich hätte das nie gedacht: Aber es spielt
                tatsächlich eine Rolle, dass ich eine Frau bin.»
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical segment interviewText'>
          <div className='ui text container'>
            <p>
              Als die «goldige Petra» später – schon als FDP-Präsidentin – in
              einem Interview mit der Lokalzeitung erwähnt, dass sie ab und an
              einen Chauffeur brauche, melden sich mehrere Pensionäre aus dem
              Kanton. Auch Christen. Es war die Zeit kurz nach dem Unfall des
              FDP-Präsidenten Phi­lipp Müller. «Seine» Petra in der Nacht auf
              dem Weg nach Genf, Bern oder Zürich, allein und müde? Eine
              Horrorvorstellung. Und so kommt es, dass die Präsidentin der FDP
              Schweiz einen 71-jährigen Unternehmer und Alt-Regierungsrat zum
              Chauffeur hat.
            </p>
            <p>
              Gössi braucht einen Moment, bis sie sich in der Politik
              zurechtfindet. Aber dann geht es schnell. Sie ist schlau, begreift
              rasch, kennt die richtigen Leute. 2007 kandidiert sie für den
              Nationalrat, bearbeitet und überzeugt von Kantonalpräsident
              Vincenzo Pedrazzini und dessen Vize Martin Wipfli. Mit Wipfli ist
              sie im Wahlherbst 2007 oft unterwegs, klebt Plakate, besucht
              Podien. «Es hat damals nicht gereicht. Aber ich merkte: Doch, das
              will ich. Das macht Spass.» Wipfli ist von ihr beeindruckt und
              bietet Gössi einen Job in seiner Beratungsfirma, der Baryon AG, in
              Zürich an. General-Guisan-Quai, beste Lage. Auch dort: Blick auf
              den See.
            </p>
            <p>
              Verantwortung übernehmen. Im Beruf, in der Politik. Gössi wird
              Fraktionspräsidentin im Schwyzer Kantonsrat und 2011, im zweiten
              Anlauf, Nationalrätin, dann Präsidentin der kantonalen Partei.
              Eine «coole Truppe» sei man gewesen, sagt Sibylle Ochsner, die mit
              Gössi im kantonalen Parlament sass. Gössi habe immer sehr
              kollegial geführt, konnte zuhören, war einfach auch nett. «Es war
              immer klar, dass sie obenaus sticht», sagt Franz Bissig, ein
              anderer Fraktionskollege von damals. «Und natürlich habt ihr
              Journalisten sie als Präsidentin unterschätzt. So wie ihr den
              Kanton Schwyz immer unterschätzt, so wie ihr uns belächelt. Aber
              sie hat es euch gezeigt!»
            </p>
            <h2>Haifische</h2>
            <p>
              Petra Gössi erlebte zwei Einstiege in Bern. Einen sanften. Einen
              brutalen. Als sie 2011 zum ersten Mal im Bundeshaus auftauchte,
              nahm kaum jemand Notiz von ihr. Sie kam in die Finanzkommission,
              machte gewissenhaft ihre Arbeit und hatte – unter jenen wenigen
              Bundeshausjournalisten, die sich in der Finanzpolitik auskennen –
              den Ruf einer Hardlinerin vom rechten Rand der FDP. Verstärkt
              wurde dieser Ruf durch den einen Moment im nationalen Rampenlicht,
              den sie während der ersten vier Jahre hatte. Sie profilierte sich
              als harte Kritikerin des Finanzausgleichs, ihr waren die Beiträge
              aus Schwyz viel zu hoch, und darum forderte sie, das Geld auf ein
              Sperrkonto einzuzahlen – bis der Bund ihrem Kanton weniger
              abknöpfen würde.
            </p>
            <p>
              Der Vorschlag war typisch für ihre ersten Jahre im Nationalrat.
              Sie wollte nicht den Fehler von Maya Lalive d’Epinay machen, der
              letzten freisinnigen Nationalrätin aus Schwyz, abgewählt 2003. Je
              länger Lalive d’Epinay in Bern Politik machte, desto weniger war
              sie im Kanton präsent – so nahmen es die Schwyzerinnen und
              Schwyzer wahr. Gössi machte das Gegenteil. Sie war ständig im
              Kanton unterwegs, machte kantonale Politik im Nationalrat. Schwyz,
              Schwyz, Schwyz. «Das musste ich tun. Sonst wäre der Sitz wieder
              weg gewesen.» Vor den Wahlen 2015 veröffentlichte die NZZ eine
              Prognose und schloss eine Niederlage Gössis nicht aus. Doch es
              erwischte nicht sie, sondern Andy Tschümperlin, den
              SP-Fraktionspräsidenten.
            </p>
            <p>
              Petra Gössi beginnt noch einmal neu im Bundeshaus. Nach dem
              unerwarteten Sieg der FDP beschliesst Philipp Müller, dass seine
              Zeit als Präsident abgelaufen ist. Der Gipser geht im Moment des
              Triumphes. Mitte Dezember 2015 gibt er seinen Rücktritt bekannt.
              Erster Favorit für seine Nachfolge: Christian Wasserfallen. Jener
              Wasserfallen, mit dem Gössi später so heftig aneinandergeraten
              wird. Doch Franz Stein­egger, der die Partei zehn Jahre als
              Präsident geführt hat und Verwaltungsratspräsident der Firma am
              General-Guisan-Quai ist, bei der Gössi arbeitet, bringt sie ins
              Spiel. «Ich könnte mir nicht nur als Innerschweizer Petra Gössi
              gut vorstellen.» Auch Vincenzo Pedrazzini kann sich das gut
              vorstellen – er ist Präsident der freisinnigen Findungskommission
              für Phi­lipp Müllers Nachfolge.
            </p>
            <p>
              Gössi ist die «Aussenseiterin» in diesem Rennen, und der Ton, der
              ihr bald entgegenschlagen wird, zeichnet sich bereits ab. In einem
              Interview wird sie gefragt: «Sie gelten als spröde, leise,
              zurückhaltend, langweilig – sind Sie das?»
            </p>
            <p>
              Was viele damals nicht merken: Gössi ist keine Aussenseiterin
              mehr. Sie gibt als Erste offiziell ihre Kandidatur bekannt – und
              beendet so das Rennen, ehe es überhaupt begonnen hat. Christian
              Wasserfallen verkündet auf Facebook seinen Verzicht, er möchte
              lieber Regierungsrat in seinem Kanton werden als Parteipräsident
              der FDP. Gössi ist die einzige Kandidatin. Unmittelbar danach
              reist die künftige Präsidentin der FDP für ihre Firma in die USA,
              keine Statements für die Presse.
            </p>
            <p>
              Es dauert lange, bis ihr die Medien im Bundeshaus diese
              Nichtverfügbarkeit verzeihen. Müller, der Gipser, die Saftwurzel,
              immer für ein druckbares Zitat gut (und oft auch für ein
              undruckbares), immer erreichbar, ein Freund der Medien. Dieser
              Müller soll durch eine blasse Frau aus dem Kanton Schwyz ersetzt
              werden? Nach seinem grossen Sieg bei den Wahlen?
            </p>
            <p>
              Es folgen Kommentare wie jener des Kolumnisten Peter Rothenbühler,
              der Gössi eine Stilberatung empfiehlt, weil die Auswahl der
              passenden Kleider «gelinde gesagt nicht zu Ihren Kernkompetenzen»
              gehöre. Politiker und Journalisten übersetzen das Kürzel FDP mit
              «Frag den Philipp», weil sie glauben, Gössi plappere nur nach, was
              der Vorgänger ihr einflüstert. In Texten wird sie als «reserviert»
              und «unfassbar» beschrieben, als eine, die ständig lacht (auf eine
              irgendwie ungute Art). Als SP-Präsident Christian Levrat bei einer
              der ersten Sitzungen mit der neuen Präsidentin des Freisinns
              zusammentrifft, redet er zwar mit Petra Gössi. Aber er schaut
              dabei meistens Samuel Lanz an, den Generalsekretär. Gössi, die
              Unsichtbare. Gössi, die Frau.
            </p>
            <p>
              Zurück in der Galerie des Alpes im Bundeshaus, dieses Mal trinkt
              Gössi Wasser, keinen Fruchtsaft. Sie sagt: «Nie in meiner
              Karriere, weder während des Studiums noch im Kantonsrat oder bei
              meiner Arbeit, war mein Geschlecht ein Thema. Nur die Leistung
              zählte. Seit ich Parteipräsidentin bin, ist das anders. Ich hätte
              das nie gedacht: Aber es spielt tatsächlich eine Rolle, dass ich
              eine Frau bin.» Diese Erkenntnis verändert Gössi. Sie stammt aus
              einer Generation von Frauen, für die viele geschlechterpolitischen
              Errungenschaften selbst­verständlich waren. Denen es normal
              schien, dass die Leistung zählt und nicht das Geschlecht. Ist aber
              nicht überall so. Vor allem im Bundeshaus nicht. Die politische
              Einmittung von Gössi (etwa in gesellschaftspolitischen Fragen wie
              der Ehe für alle) hat natürlich mit ihrem Amt als Präsidentin zu
              tun. Aber eben auch damit, dass sie eine Frau ist. Die nationale
              Politik, das Bundeshaus (und die Bundeshaus­medien) sind noch
              immer so männlich dominiert wie wenig andere Gesellschaftsbereiche
              der Schweiz. Frauen müssen im Bundeshaus mehr leisten als ihre
              männlichen Kollegen. Frauen werden belächelt. Frauen müssen mehr
              dafür arbeiten, ernst genommen zu werden. Bei Petra Gössi dauert
              dieser Prozess noch immer an – drei Jahre nach ihrer Wahl zur
              FDP-Präsidentin.
            </p>
            <p>
              Dass auch ihr Umfeld männlich dominiert ist, diese Ironie entgeht
              ihr nicht. Es waren fast immer Männer, die sie gefördert haben.
              Leute wie Alois Christen, Franz Steinegger oder ihr Arbeitgeber
              Martin Wipfli. Wird die Frontfrau also doch aus dem Hintergrund
              gecoacht, ja, dirigiert, wie man in Bundesbern gerne flüstert?
              Kaum. Sie ist die Chefin. Eine Chefin mit Gespür. Alois Christen
              etwa, der väter­liche Freund und Bauunternehmer, verlor vor etwas
              über einem Jahr den ältesten Sohn bei einem Unfall. Ein schwerer
              Verlust. Wer heute wem hilft mit den Chauffeurfahrten, wer auf wen
              aufpasst: Es ist nicht so deutlich.
            </p>
            <h2>Spielen</h2>
            <p>
              Unterschätzt zu werden: Das ist das grosse Problem von Gössi, und
              es ist ihr grosser Vorteil. Sie erlebt es jetzt wieder, im
              Frühjahr 2019, im Kampf mit der eigenen Fraktion. Die freisinnigen
              Hardliner im Bundeshaus versuchen alles, um den neuen Klimakurs zu
              sabotieren, die Partei zurück auf den rechten Weg zu bringen. Ende
              Mai will die Parteispitze die Auswertung der Mitgliederbefragung
              präsentieren und das daraus entstandene Positionspapier. Zwei Tage
              vor der Präsentation erhält der «Tages-Anzeiger» einen Entwurf des
              Papiers zugespielt. Ein Kompendium des Horrors für jeden
              Freisinnigen: Fahrverbote in den Innenstädten, ein Verbot von
              Elektroheizungen, längerfristige Subventionen für die energetische
              Gebäudesanierung. «Dieser bunte Strauss von Verboten wird der FDP
              bei den Wahlen schaden», sagt ein Mitglied der Bundeshausfraktion.
            </p>
            <p>
              Gössi schäumt. Als die Umfrageergebnisse in einer Holzfabrik in
              Langenthal präsentiert werden (die Ergebnisse stützen
              grösstenteils den neuen Kurs), gibt die Präsidentin den Tarif
              durch. Sie wird im Kampf mit der eigenen Fraktion (und das ist es
              jetzt) nicht nachgeben. «Es ist destruktiv, feige und vor allem
              auch dumm, mit vorsätzlichen Leaks Schaden anrichten zu wollen»,
              sagt sie zum Auftakt der Medienkonferenz. Sie sagt es hart und
              entschlossen.
            </p>
            <p>
              Das geleakte Papier war nur ein Entwurf und wird noch entscheidend
              abgemildert. Doch diese Abschwächung bleibt eine Randnotiz. Als
              nach der Pressekonferenz der Reporter des Schweizer Fernsehens
              wiederholt nach dem Papier fragt, einmal, zweimal, dreimal, da
              verliert Gössi die Contenance. «Sie stellen immer die gleiche
              Frage!» Generalsekretär Lanz beobachtet die Szene und sagt: «Noch
              nie war Politik so anstrengend.»
            </p>
            <p>
              Kurz vor der alles entscheidenden Delegiertenversammlung werden
              die neuen Wahlprognosen veröffentlicht. Sie sind negativ für die
              FDP, zum ersten Mal seit langer Zeit. Vorteil für Gössis Gegner.
              Das Momentum auf deren Seite. Christian Wasserfallen, der
              Intimfeind, darf in die Sendung «10vor10» von SRF: «Als
              Freisinniger muss man gegenüber allen Technologien offen sein.»
              Wasserfallen wirbt dafür, die Atomtechnologie ins Umweltpapier
              seiner Partei zu schreiben. Kampfansage.
            </p>
            <p>
              Jetzt aber. Die zwei Tage sind um. Es ist Samstag, der 22. Juni
              2019, die Delegiertenversammlung, Tag der Entscheidung. Gössi ist
              schon seit acht Uhr hier, zweieinhalb Stunden vor Sitzungsbeginn.
              Der Eingang des Hotels Spirgarten in Zürich-Altstetten wird von
              bewaffneten Sicherheitskräften bewacht. Ein Novum. Die Partei
              fürchtet sich vor illegalen Aktionen durch die Klimajugend. Dabei
              sitzen Gössis wahre Gegner drinnen im Saal. Fünfzig Anträge gibt
              es zum Klimapapier. Vor allem die Jungfreisinnigen wollen diesen
              Tag nutzen, um das Papier entscheidend abzuschwächen. Zurück zu
              den liberalen Wurzeln! #DankeGössi. Doch zuerst redet die Chefin –
              und holt zum Präventivschlag aus: «Sie haben jetzt die
              Möglichkeit, Ihre Individualpositionen einzubringen», sagt Gössi,
              «aber danach, meine sehr verehrten Damen und Herren, erwarte ich
              von allen, dass die Beschlüsse der Delegiertenversammlung
              akzeptiert und respektiert werden.»
            </p>
            <p>
              Es dauert weitere eineinhalb Stunden, bis die Diskussion über das
              ominöse Papier eröffnet wird. Eineinhalb Stunden, in denen Petra
              Gössi und ihre Getreuen den Rahmen für die Debatte setzen. Deren
              Botschaft ist so deutlich, dass sie jeder hier drin begreift: Wir
              wollen das. Wir wollen das jetzt.
            </p>
            <p>
              In Videobeiträgen erklären Freisinnige aus allen Landesteilen, was
              sie selbst im Alltag für den Umweltschutz machen. In einer
              Grundsatzrede wiederholt Petra Gössi ihr Mantra: «Eine liberale
              Umweltpolitik ist eine Chance für Gesellschaft und Wirtschaft.»
              Auf der Bühne begründen Firmenvertreter, warum die freisinnige
              Kehrtwende in Umweltfragen so bitter notwendig ist.
            </p>
            <p>
              Dann endlich beginnt die Behandlung der Anträge. Und schon nach
              wenigen Minuten, als das CO2-Emis­sionsziel entscheidend
              verschärft wird, ist klar: Es wird ein Triumph für Gössi. «Das
              freut mich schon sehr, wie das heute läuft», sagt sie in der
              Mittagspause im Vorbeigehen. Sie gestattet sich ein Lächeln. Seit
              ihrer Präventivschlag-Rede vom späten Vormittag hat sie nichts
              mehr zu den Delegierten gesagt. Es war nicht nötig. Still und
              ernst sass sie vorne auf dem Podium und sah zu, wie alles seinen
              Gang nahm. Den von ihr gewünschten Gang.
            </p>
            <p>
              Das Papier der Parteispitze ist am Ende des Tages grüner als am
              Anfang. Die FDP will jetzt offiziell eine Flugticketabgabe, eine
              Treibstoffabgabe auf Benzin und Diesel, eine CO2-Lenkungsabgabe
              und ein Bekenntnis zum Pariser Klimaabkommen (netto null
              CO2-Emissionen bis 2050). Die Delegierten aus den Kantonen drücken
              die Mitglieder der Fraktion und die anderen Kritiker an die Wand,
              als wäre es nichts.
            </p>
            <p>
              Es ist eine spektakuläre Versammlung, zu vergleichen mit der
              Delegiertenversammlung von 1995 in Interlaken. Damals war es
              umgekehrt, damals überrumpelten die Delegierten die Parteispitze
              und schrieben der FDP den EU-Beitritt ins Programm. Es kostete die
              FDP die Wahlen. Wiederholt sich die Geschichte? Wie lange hält das
              an? Hallt das nach? Klar ist: Die Versammlung hat Konsequenzen.
              Inhaltliche, personelle. Alain Schwald, jungfreisinniger Kritiker
              des grünen Kurses, gibt in der Woche darauf seinen Rücktritt als
              Präsident der FDP Bezirk Affoltern bekannt. «Was ist das für eine
              Partei!», hatte er während der Delegiertenversammlung gerufen.
            </p>
          </div>
        </div>

        {/* ZITAT */}
        <div className='ui vertical segment zitat left'>
          <div
            className='imageHolder'
            style={{
              backgroundImage: ' url("images/goessi2.jpg")',
              backgroundPositionY: 'top'
            }}
          />
          <div className='textHolder'>
            <div className='quote'>
              <p>
                «Ich habe in den letzten Monaten in menschliche Abgründe
                geblickt.»
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical segment interviewText'>
          <div className='ui text container'>
            <p>
              Christian Wasserfallen erlebt das Ende der Versammlung nicht mehr
              – er fährt zum Formel-E-Grand-Prix nach Bern. In der Woche darauf
              tritt er als FDP-Vizepräsident zurück. «Ich habe es gesehen», sagt
              er dem Portal nau.ch. Später wird Gössi sagen: «Ich habe ihm drei
              Möglichkeiten gegeben. Entweder du unterstützt unsere Position. Du
              schweigst. Oder du gehst. Sonst wird es schwierig als
              Vizepräsident.» Wasserfallen selber will im Nachhinein nicht mehr
              über seinen Entscheid und seine Beziehung zur Parteispitze reden.
              «Ich möchte davon absehen, hier aktiv zu werden», schreibt er auf
              Anfrage.
            </p>
            <p>
              In den Medien wird die FDP-Präsidentin für die erfolgreiche
              Delegiertenversammlung gefeiert. «Petra und die Wölfe», titelt die
              NZZ. Im Text heisst es: «Die Basis trägt nicht nur den neuen,
              grüneren Klimakurs mit, sie setzt auch ein starkes Zeichen der
              Loyalität gegenüber ihrer Parteipräsidentin. Für sie ist Petra
              Gössi nicht Greta Gössi. Sie ist Petra Courage.»
            </p>
            <p>
              Gössi liest nicht jeden Text über sich, sagt sie, diesen aber
              schon. Petra Courage. Hat ihr gefallen. Sie sitzt jetzt in ihrem
              kleinen blauen Audi und fährt von Tuggen nach Zürich. Sie war an
              einem Ausflug mit ihren alten Kollegen aus dem Kantonsrat und ist
              kaputt. Die Stimme krächzt schon wieder. Draussen ist es 36 Grad,
              drinnen sitzt Gössi im klimatisierten Auto, noch immer erkältet.
              Raubbau. Morgen muss sie an eine Delegiertenversammlung im Kanton
              Uri, gestern war sie bei den Rotariern, vorgestern … keine Ahnung
              mehr. Es ist etwas viel im Moment.
            </p>

            <Waypoint
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'Interactions',
                    event_action: 'vertical-scroll',
                    event_label: '75ContentRead'
                  })
                }
              }}
            />
            <p>
              Das Gedreckele der vergangenen Tage und Wochen sei extrem gewesen,
              die Missgunst, das Gegeneinanderschaffen. Sie hat mehr Briefe
              bekommen als nach der Umsetzung der Masseneinwanderungsinitiative.
              Unterstützende und weniger unterstützende. «Das war richtig hart.
              Ich habe in den letzten Monaten in menschliche Abgründe geblickt.»
            </p>
            <h2>Lust</h2>
            <p>
              «Politik ist nicht das Einzige in ihrem Leben. Darum konnte sie
              das mit dem Klima durchziehen. Wenn es nicht geklappt hätte, dann
              hätte sie gesagt: Dann wählt mich halt ab.» Vincenzo Pedrazzini
              sitzt auf einer Terrasse am Ende der Schweiz, Campo heisst das
              Dorf, acht Einwohner, zuhinterst im Maggiatal. Dreimal umsteigen
              von Locarno, die Busse werden dabei immer kürzer, die Kurven
              enger, die Fahrer waghalsiger.
            </p>
            <p>
              Pedrazzini war lange Zeit Vizepräsident der Partei, unter Fulvio
              Pelli und Philipp Müller, zweimal leitete er einen nationalen
              Wahlkampf. Seit ein paar Jahren ist er weg vom Unterland. Er hat
              sein Patentanwaltsbüro an die ehemaligen Mitarbeiter verkauft und
              führt jetzt mit der Lebensgefährtin ein Hotel in Campo, seinem
              Bürgerort. Abgeschieden, dafür mit Gault-Millau-Küche und einer
              Auswahl von zweihundert Whiskys. Samuel Lanz, der Generalsekretär,
              ist regelmässig hier, Philipp Müller, die ehemalige
              Fraktionschefin Gabi Huber und andere Grössen des Freisinns.
            </p>
            <p>
              Pedrazzini ist eine der meistunterschätzten Figuren der FDP. Er
              hat massgeblich dazu beigetragen, dass sich der Freisinn in der
              Zeit von Fulvio Pelli ­geeint hat (rechts der Mitte). Auch sind
              ihm die neuen Strukturen innerhalb der Partei zu verdanken. Ohne
              Pedrazzini hätten die kantonalen Präsidenten nicht jenes Gewicht,
              das sie heute haben – ein Korrektiv zur Fraktion, entscheidend für
              den parteiinternen Erfolg des Klimakurses. «Jetzt muss sich
              einfach die Fraktion noch daran halten. Ich wünschte mir dort
              schon etwas mehr Disziplin.»
            </p>
            <p>
              Als er noch aktiv in der Partei war, erlebte er, wie die
              Katastrophe in Fukushima den Freisinn 2011 auf dem falschen Fuss
              erwischte. «Da waren wir nicht gut.» Umso besser mache es nun
              Petra Gössi. Pelli sei der Intellektuelle gewesen. Müller der
              Bauchmensch. Und Gössi die Ungebundene, Authentische. Sie nehme
              sich nicht so ernst wie die anderen, sie könne etwas wagen.
            </p>
            <p>
              Auch Martin Wipfli, Gössis Chef bei der Beratungsfirma und
              ehemaliger Vize der FDP Schwyz, sagt: «Sie ist ehrlich. Sie ist
              immer, wie sie ist. In der Schweizer Politik ist das sehr
              untypisch.» Zudem könne sie zuhören und habe ein wahnsinnig gutes
              Gespür.
            </p>
            <p>
              Ist es Gespür? Oder Opportunismus? Tiefe Überzeugung? Und wäre es
              schlimm, wenn jemand in der Politik aus praktischen Gründen etwas
              tut – und nicht aus ideologischen?
            </p>
            <p>
              Es ist nicht einfach, fundierte Kritik zu Petra Gössi einzuholen.
              Kritik, die über das hinausgeht, was zu Beginn ihrer
              Präsidentschaft über sie geschrieben wurde, als sie als blass und
              langweilig galt. «Ihr Kurswechsel war mutig», sagt zum Beispiel
              Tiana Moser, die Fraktionschefin der Grünliberalen. «Aber meint
              sie das auch wirklich? Wirklich? Bis heute spüre ich bei Petra
              Gössi keine echten Überzeugungen.» Während der Legislatur habe die
              FDP zu allem Nein gesagt, was auch nur ansatzweise nach
              Umweltschutz roch, sagt Moser. «Auch nach vielen Gesprächen mit
              Freisinnigen bin ich nicht überzeugt, dass das ein tatsäch­licher
              Wandel ist. Bis jetzt ist es primär eine Strategie.» Ob diese
              verfängt? Moser weiss es nicht.
            </p>
            <p>
              Die Sommerferien sind vorbei, und Petra Gössi sieht anders aus.
              Gesünder. Zwei Wochen war sie mit ihrem Freund in Italien, am
              Strand. «Die Frau, die mir über Mittag jeweils ein Panino verkauft
              hat, meinte am Schluss, es sei schön, dass ich doch noch etwas
              Farbe bekommen hätte. Ich sei so grau gewesen am Anfang!» Gössi
              lacht. Das macht sie jetzt wieder öfter. Sie hatte eben ein
              Treffen mit ihrer Werbeagentur im Zürcher Kreis 4. «Heimat» heisst
              die Agentur und macht sonst Werbung für Banken,
              Telekommunikationsunternehmen und Baumärkte.
            </p>
            <p>
              Diesen Sommer für die FDP. Eben haben Gössi und Wahlleiter Lanz
              die Plakate abgesegnet, es geht um Heimat und Vorwärtskommen und
              Fortschritt. Fröhliche, glatt polierte Polit-PR. Auch der
              Generalsekretär sieht besser aus. Er ist mit seiner Frau zwei
              Wochen quer durch England gewandert und hat danach offenbar
              beschlossen, sich wieder zu rasieren.
            </p>
            <p>
              Fast schon aufgekratzt ist die Stimmung auf der Fahrt mit dem Tram
              vom Kreis 4 ins Seefeld. «Die Themenkonjunktur ist immer noch
              nicht auf unserer Seite», sagt Gössi. Dass das Klima immer noch so
              wichtig ist – es hilft dem Original. Es hilft den Grünen und
              Grünliberalen – egal, wie umweltschützerisch sich der Freisinn
              gibt. «Doch wir haben es durchgerechnet, und es sieht nicht
              schlecht aus. Wenn wir unseren Wahlanteil halten können, dann ist
              das ein Erfolg.» Die SP überholen, wie es das offizielle Ziel der
              Partei ist? Davon redet Gössi nicht.
            </p>
            <p>
              Später, beim Essen in der Blauen Ente, erzählt Gössi vom Anfang
              ihrer Präsidentschaft. Es sei hart gewesen. «Da bleibt dir nicht
              viel anderes übrig, als einfach weiterzuarbeiten.» Lanz erinnert
              sich an eine Strategiesitzung der neuen Parteileitung auf der
              Rigi. Erkenntnis Nummer 1: Petra als Absender stärken. «Das ist
              uns gelungen.»
            </p>
            <p>
              In der Blauen Ente reden sie vom täglichen Wahnsinn der Schweizer
              Politik. Von Krisensitzungen am Sonntagmorgen, wenn in irgendeiner
              Sonntagszeitung wieder irgendetwas steht. Dass Lanz sein Handy
              selbst in der Nacht auf laut stellt, erreichbar für definierte
              Kontakte. Dass Gössi normalerweise den Flugmodus reinmacht. Dass
              sie beide gerne mehr lesen würden (Gössi hat in den Ferien mit
              Joël Dickers zweitem Roman angefangen, um ihr Französisch zu
              verbessern), die tägliche Flut aber einfach zu gross sei. Politik
              in der Schweiz ist für die meisten Menschen etwas Schwerfälliges,
              stabil und auf gute Art langweilig. Für Gössi und Lanz ist es ein
              Hochgeschwindigkeitsjob.
            </p>
            <p>
              Warum tut man sich das an? «Es war eine Türe, durch die ich gehen
              konnte», sagt Gössi. «Solche Möglichkeiten muss man ergreifen. Ich
              kann für meine Partei etwas bewirken.» Sie sagt zuerst «Verein»,
              korrigiert sich dann, dabei wäre es genauso richtig gewesen.
              Vielleicht noch richtiger. Petra Gössi macht den Job als
              Parteipräsidentin, weil sie ihn kann. Das hat sie in den
              vergangenen drei Jahren be­wiesen. Sie macht ihn, weil sie einen
              Unterschied macht («Wenn die FDP ihre Politik ökologischer
              gestaltet, hat das einen Einfluss auf die gesamte bürgerliche
              Politik»), und sie macht ihn, weil er manchmal aufregend ist.
              «Didier Burkhalter hat uns nur zwei Stunden vor der Öffentlichkeit
              über seinen Rücktritt informiert, weisst du noch, Sämi?» Der
              Generalsekretär nickt, Gössi redet weiter. «Bämbämbäm machte es im
              Generalsekretariat. Wir haben uns nur noch angeschrien, aber am
              Schluss kam alles gut. Eine Bundesratswahl hautnah zu erleben, das
              ist ziemlich eindrücklich.» Schlachtengeschichten. Momente, die
              mit der Zeit ihren Schrecken verlieren und zu Anekdoten werden.
            </p>
            <h2>Happy End?</h2>
            <p>
              Es ist Herbst geworden, der Sommer 2019 war lange nicht so heiss
              wie der letzte, doch die Stimmung bleibt grün. Im Kaufleuten
              findet eine Diskussion zum Klimawandel statt, die Leute stehen
              Schlange. Auf dem Podium eine junge Aktivistin, ein
              Wissenschaftler, ein SVP-Nationalrat und Petra Gössi. Die
              Sympathien des Publikums sind eindeutig verteilt. Es gibt Applaus
              für den Wissenschaftler, heftigen Applaus für die Klimaaktivistin,
              Buhrufe für den SVP-Nationalrat. Gössi wird vom Pu­blikum in Ruhe
              gelassen. Sie sagt Sätze wie: «Jede Lösung muss ökonomisch,
              ökologisch und sozialverträglich sein. Sonst gibt es keine
              Mehr­heiten dafür.» Man dürfe nicht überschiessen, sonst komme es
              nicht gut. «Wir haben eine andere Aufgabe als die Aktivisten auf
              der Strasse. Wir müssen Lösungen bringen.»{' '}
            </p>
            <p>Zurückhaltender Applaus.</p>
            <p>
              «Das Publikum an solchen Veranstaltungen ist aufmerksamer
              geworden», erklärt Petra Gössi am Tag darauf an ihrem Arbeitsplatz
              in Zürich (der mit dem Blick auf den See). Kurz vor der
              Podiumsveranstaltung hat der Bundesrat beschlossen, die Schweiz
              bis zum Jahr 2050 klimaneutral zu machen. Die Haltung der FDP ist
              jetzt auch die Position des Bundesrats. «Das hat mich extrem
              gefreut. Unsere Position ist massiv gestärkt worden.»
            </p>
            <p>
              Läuft gar nicht so schlecht, dieses zweite halbe Jahr. Läuft sehr
              viel besser als die erste Hälfte. Ende August feiert die Partei in
              Aarau sich selber, Tag der FDP nennen sie es. Euphorische Musik,
              bunte Videoclips, Konfettikanonen, zwölfhundert Ballone,
              Gratiswürste, alles sehr amerikanisch. Nur das Bier müssen die
              Freisinnigen selber zahlen. Gössi hält die Abschluss­rede, so
              aufgeputscht, wie sie selten Reden hält. Sie hat sie geübt, das
              hilft, und das mit den Gefühlen macht sie bewusst. «Man muss den
              Leuten auch manchmal die Emotionen zwicken.» Sie macht es heute
              wie Müller. Inhalte sind nicht so entscheidend, heute geht es um
              die Atmosphäre, um das Miteinander. Wir werden gewinnen!
            </p>
            <p>
              Tatsächlich sind die letzten Umfragen positiv, plötzlich wieder.
              Noch einen knappen Monat dauert es bis zu den Wahlen. Ob das hält?
              Ob es reicht? Minus 0,5 Prozent, plus 0,5 Prozent.
              Unschärfebereich.
            </p>
            <p>
              Klar ist: Am 20. Oktober hört es nicht einfach auf. Ihre Fraktion,
              die sie in den vergangenen Monaten so gegen sich aufgebracht hat,
              wird auch nach den Wahlen zu grossen Teilen die gleiche sein.
              Frohes Wiedersehen. Im Winter wird das CO2-Gesetz erneut vom
              Nationalrat behandelt. Was werden dann Leute wie Christian
              Wasserfallen machen? Was geschieht, wenn der Gewerbeverband von
              FDP-Nationalrat Hans-Ulrich Bigler ein schärferes CO2-Gesetz per
              Referendum bekämpft? Was, wenn die SVP wieder stärker wird? Die
              Themenkonjunktur dreht? Wird die FDP dann von ihrem Kurswechsel
              eingeholt? Wie so oft in der Geschichte?
            </p>
            <p>
              Wer weiss das heute schon. Manchmal macht man Dinge einfach, weil
              man sie machen kann.{' '}
            </p>
            <p>Weil eine Türe offen steht. </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'contentBottom'
              })
            }
          }}
        />

        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war das Porträt?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            ['Porträt', 'Philipp Loser, Das Magazin, Tages-Anzeiger'],
            ['Fotos', 'Joan Minder'],
            ['Digitale Umsetzung', 'Mathias Lutz, Interaktiv-Team']
          ]}
          mediaName='dasmagazin'
          fullMediaName='Das Magazin'
          hidePortfolioTeaser
        />

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'pageBottom'
              })
            }
          }}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
